import _ from "lodash";
import React from "react";

import { Tag } from "@toddle-edu/ds-web";
import { FolderFilled } from "@toddle-edu/ds-icons";
import { colors } from "@toddle-edu/ds-theme";

import classes from "./TaggedFolders.scss";
import { COLORS_MAPPING_FOR_CHIP } from "Post/modules/PostModule";

const TaggedFoldersV2 = React.memo(props => {
  const {
    folders,
    containerStyle = {},
    singleTagContainerStyle = {},
    tagSize = "small",
    showFolderIcon = true,
    isClosable = false,
    onClose = () => {},
    folderSize = "x-small",
  } = props;

  if (_.isEmpty(folders)) return null;
  return (
    <div className={classes.folderTagsContainer} style={containerStyle}>
      {_.map(folders, (folder, index) => {
        return (
          <div
            className={classes.folderTag}
            style={singleTagContainerStyle}
            key={_.get(folder, "id", _.get(folder, "name"))}
            data-test-id="journal-postcreation-selectedfolderitem"
          >
            <Tag
              key={folder?.id}
              size={tagSize}
              prefix={
                <FolderFilled
                  data-test-id={`journal-postcreation-selectedfolderitemcolor-${folder?.color}`}
                  style={{
                    color: _.get(
                      COLORS_MAPPING_FOR_CHIP,
                      folder?.color,
                      colors.surfaceDarkActive
                    ),
                    flexShrink: 0,
                  }}
                  size={folderSize}
                />
              }
              isClosable={isClosable}
              onClose={
                isClosable ? () => onClose({ folder, index }) : undefined
              }
              testId="journal-postcreation-selectedfolderitemtag"
            >
              <span
                style={{
                  color: colors.textDefault,
                  fontSize: "1.6rem",
                  fontWeight: "500",
                  lineHeight: "2.4rem",
                }}
              >
                {folder?.name}
              </span>
            </Tag>
          </div>
        );
      })}
    </div>
  );
});
TaggedFoldersV2.displayName = "TaggedFoldersV2";

export default TaggedFoldersV2;
